export default ({ COLORS }) => ({
  heading: ({ size, printMode }) => ({
    margin: '0',
    fontSize: printMode ? '32px' : size(4, { scaleFactor: 'sm' }),
    lineHeight: '1.1',
    fontWeight: 'bold',
    color: COLORS.TEXT.OFF_BLACK.NORMAL
  })
})
